import { useCallback } from 'react'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { dispatchCepEnteredAndConfirmedEvent } from 'src/utils/amplitude/cepEvents'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'

interface CloseModalArgs {
  shouldTrackClose: boolean
  hasInputValue?: boolean
  buttonName?: string
  skipTracking?: boolean
}

interface TrackPostalCodeConfirmedArgs {
  source?: string
  modalName?: string
}

export function usePostalCodeModalTracking() {
  const { pageData } = useGlobalContext()

  const trackModalClose = useCallback(
    ({
      shouldTrackClose,
      hasInputValue,
      buttonName,
      skipTracking,
    }: CloseModalArgs) => {
      if (!shouldTrackClose || skipTracking) {
        return
      }

      dispatchAmplitudeEvent({
        eventName: hasInputValue
          ? 'Click Button Modal'
          : 'CEP Modal Closed Without Entry',
        eventData: {
          ...getStandardObject(pageData),
          'modal nome': 'Confira as melhores ofertas e fretes para sua região!',
          'modal botao nome': buttonName,
        },
      })
    },
    [pageData]
  )

  const trackPostalCodeConfirmed = useCallback(
    async (
      postalCode: string,
      {
        source = 'Modal inicial',
        modalName = 'Confira as melhores ofertas e fretes para sua região!',
      }: TrackPostalCodeConfirmedArgs = {}
    ) => {
      await dispatchCepEnteredAndConfirmedEvent({
        pageData,
        cep: postalCode,
        modalName,
        source,
      })
    },
    [pageData]
  )

  return {
    trackModalClose,
    trackPostalCodeConfirmed,
  }
}
